---
title: "Introducing entire agent-help: Entire CLI Guidance Built for Agents"
description: "Give coding agents an always-current map of the Entire CLI, reducing tokens spent on command discovery, retries, and unnecessary questions."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. We’re excited to introduce [`entire agent-help`](https://docs.entire.io/cli-reference/agent-help), a new CLI command built to give your coding agents a guide to the Entire CLI they can consult directly.

<CloudflareStreamVideo
  videoId="b6a66fd473ecf29b0b505a35f868f8f7"
  title="Entire agent help"
  aspectRatioPercent="63.084112149532714%"
  autoplay
/>

We noticed our community embraced [Skills](https://github.com/entireio/skills) because they give agents reliable, repeatable workflows for using Entire. But we found ourselves continuously updating CLI guidance inside those Skills as commands and flags evolved.

`entire agent-help` moves that command guidance into the CLI itself, where it is generated live and always matches the installed version. Agents get enough context to choose the right command and can look up details as needed. That means fewer tokens spent navigating the CLI and more context for the actual work, while Skills can focus on guiding agent workflows.

## How It Works

When your agent runs `entire agent-help`, Entire returns a map of the CLI:

```shell
entire agent-help
```

The map shows what Entire can do and connects common tasks to commands, such as searching past checkpoints, generating a dispatch, reviewing a branch, or managing agent integrations. From there, your agent can drill into a specific command to see its exact options.

`entire agent-help` also detects the current repository and only shows features available there, helping agents avoid unnecessary questions and commands they cannot use.

## Try It

[Update](https://docs.entire.io/updating) to [Entire CLI 0.8.42](https://github.com/entireio/cli/releases/tag/v0.8.42) or later, then let your agent run `entire agent-help` from any Entire-enabled repository. Agents and other tools can also request structured output with JSON:

```shell
entire agent-help --json
```

See the [`entire agent-help` documentation](https://docs.entire.io/cli-reference/agent-help) for the full command reference. Boop.
